/**
 * TEAM: customs_platform
 *
 * Global styles using Latitude design system typography and base styles
 */

/* eslint import/prefer-default-export:0 */

import { createGlobalStyle } from "styled-components";
import { uiFontFamily, semanticColors } from "./latitudeTheme";

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    color: ${semanticColors.textPrimary};
    padding: 0;
    margin: 0;
    font-family: ${uiFontFamily};
    font-size: 14px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  a {
    color: inherit;
    text-decoration: none;
  }
  
  * {
    box-sizing: border-box;
  }
  
  #__next {
    height: 100%;
  }
  
  /* Hide LastPass icons */
  div[data-lastpass-icon-root] { 
    display: none; 
  }
  
  div[data-lastpass-root] { 
    display: none; 
  }
`;
